// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","logo":"header_logo__dpz63"};